import React from 'react';
import './style.scss';

const ColourTitle = ({ className = '', colour = 'black', children }) => {
	return <h3 className={`text-${colour} colour-title ${className}`}>{children}</h3>;
};

export default ColourTitle;
